module.exports = __webpack_public_path__ + "assets/img/lg-webapp-stiftung.72bca8cc.svg";